<template>
    <div tabindex="0" class="menu menu-sm dropdown-content left-1/2 translate-x-[-50%] min-w-72 mt-3 p-6 shadow border border-border bg-base-200 rounded-lg z-50">
        <ul tabindex="0">
            <li>
                <button
                    type="button"
                    tabindex="1"
                    class="btn btn-secondary w-full"
                    @click="logoutGuest()">
                    {{ t('customer.navigation.endGuestSession') }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { useCustomer } from '#imports'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const { logoutGuest } = useCustomer()
</script>
